// extracted by mini-css-extract-plugin
export default {"container":"PopupDownYesNo_container__6QgSG","input":"PopupDownYesNo_input__Le4YF","buttons":"PopupDownYesNo_buttons__2RYey","request":"PopupDownYesNo_request__s7JFk"};